import React from 'react';

export function cn(...args) {
	return args.filter(Boolean).join(' ');
}

export function mapEdgesToNodes(data) {
	if (!data.edges) return [];
	return data.edges.map((edge) => edge.node);
}

export function filterOutDocsWithoutSlugs({ slug }) {
	return (slug || {}).current;
}
export function generateSlugs(name) {
	return name.replace(/:/g, '').replace(/\s+/g, '-');
}

export function LinkRenderer(props) {
	return (
		<a href={props.href} rel='noreferrer'>
			{props.children}
		</a>
	);
}

export function isExecutive(user) {
	return user.peopleRoles.filter((role) => role === 19).length > 0;
}

/** Strapi people-role "HoSA Admin" — published id 3, documentId e74ijf0evowbg759vrc5twvc */
const HOSA_ADMIN_ROLE_IDS = new Set([
	3,
	'3',
	'e74ijf0evowbg759vrc5twvc',
]);

export function isHosaAdmin(user) {
	if (!user) return false;

	const roleIds = Array.isArray(user.peopleRoles) ? user.peopleRoles : [];
	if (roleIds.some((role) => HOSA_ADMIN_ROLE_IDS.has(role))) {
		return true;
	}

	const roleTitles = Array.isArray(user.userRoles) ? user.userRoles : [];
	return roleTitles.some(
		(title) => String(title).trim().toLowerCase() === 'hosa admin'
	);
}
